module.exports = __webpack_public_path__ + "media/images/x-581036bddac92b6a6c6a492169d049bf.svg";